// removed by extract-text-webpack-plugin
module.exports = {"mandat__svg__small":"nrk-v17-static-mandat__svg__small","large":"nrk-v17-static-large","mandat__svg__large":"nrk-v17-static-mandat__svg__large"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/mandatfordeling/MandatfordelingTable/svg/index.css
// module id = 255
// module chunks = 0 1